module.exports = __webpack_public_path__ + "img/player-example.a58a8c34.png";